const STATS = [
  { value: "$1.24B", label: "Property Money Managed" },
  { value: "34%", label: "Average Return Per Year" },
  { value: "412", label: "Deals Found For Clients" },
  { value: "0", label: "Decisions Made From Fear" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-ink border-y border-white/5 grain"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className={`px-6 sm:px-10 py-10 sm:py-14 border-white/5 ${
              i !== STATS.length - 1 ? "lg:border-r" : ""
            } ${i % 2 === 0 ? "border-r lg:border-r" : ""} ${
              i < 2 ? "border-b lg:border-b-0" : ""
            }`}
            data-testid={`stat-${i}`}
          >
            <div className="data-label mb-4">{`/ 0${i + 1}`}</div>
            <div className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-none tracking-tight">
              {s.value}
            </div>
            <div className="mt-4 text-xs sm:text-sm tracking-[0.25em] uppercase text-white/50">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
